import { render, staticRenderFns } from "./navigation.vue?vue&type=template&id=ee68ef9c&scoped=true&"
import script from "./navigation.vue?vue&type=script&lang=js&"
export * from "./navigation.vue?vue&type=script&lang=js&"
import style1 from "./navigation.vue?vue&type=style&index=1&id=ee68ef9c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee68ef9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee68ef9c')) {
      api.createRecord('ee68ef9c', component.options)
    } else {
      api.reload('ee68ef9c', component.options)
    }
    module.hot.accept("./navigation.vue?vue&type=template&id=ee68ef9c&scoped=true&", function () {
      api.rerender('ee68ef9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/service/navigation.vue"
export default component.exports